import(/* webpackMode: "eager" */ "/home/adminquina/quina_releases/20260905123918/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/adminquina/quina_releases/20260905123918/components/atoms/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/adminquina/quina_releases/20260905123918/components/ui/loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/adminquina/quina_releases/20260905123918/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/adminquina/quina_releases/20260905123918/hooks/use-auth.tsx");
;
import(/* webpackMode: "eager" */ "/home/adminquina/quina_releases/20260905123918/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
